import APIRequestHelper from '../helpers/api-request-helper';

const TransactionService = {
  async getGridTransactionDatasource() {
    return APIRequestHelper.getDataManager('POST', 'admin/grid_transactions');
  },
};

export default TransactionService;
